import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _findIndex from 'lodash/findIndex';
import _isEmpty from 'lodash/isEmpty';
import _isNumber from 'lodash/isNumber';
import _isString from 'lodash/isString';
import { ALIGNMENT_TO_CLASS_MAP, DEFAULT_CONTAINER_CLASS, DEFAULT_ALIGNMENT_CLASS } from './PatternedImageRow.constants';
export function getImageId(image) {
  if (_isString(image)) {
    return image;
  }
  var _id = image._id;
  return _id;
}
export function getContainerClassName(pattern) {
  var alignment = pattern.alignment;
  var flexAlignmentClass = ALIGNMENT_TO_CLASS_MAP[alignment] || DEFAULT_ALIGNMENT_CLASS;
  return [DEFAULT_CONTAINER_CLASS, flexAlignmentClass].join(' ');
}
export function getContainerStyle(pattern) {
  var _ref = pattern || {},
    width = _ref.width,
    height = _ref.height;
  var style = {};
  if (_isNumber(width)) {
    style = _objectSpread(_objectSpread({}, style), {}, {
      flex: width / 100
    });
  }
  if (_isNumber(height)) {
    style = _objectSpread(_objectSpread({}, style), {}, {
      height: "".concat(height, "%")
    });
  }
  return style;
}
export function getImagePattern(image, images, patterns) {
  if (_isEmpty(patterns)) {
    return null;
  }
  var imageId = getImageId(image);
  if (!imageId) {
    return patterns[0];
  }
  var imageIndex = _findIndex(images, function (aImage) {
    return getImageId(aImage) === imageId;
  });
  if (imageIndex < 0) {
    return patterns[0];
  }
  return patterns[imageIndex % patterns.length];
}